function DragFingerIcon() {
	return (
		<svg
			width="74"
			height="93"
			viewBox="0 0 74 93"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<ellipse
				cx="38.9891"
				cy="12.6464"
				rx="11.9008"
				ry="11.9008"
				fill="url(#paint0_radial_391_2151)"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M40.8504 6.04382C36.8769 4.9872 32.7921 7.33796 31.7324 11.3192L31.732 11.3209L23.379 42.5078L23.3787 42.5086C22.8485 44.4731 20.908 45.6811 18.9536 45.3321L16.3733 40.0121L16.3719 40.0092C14.4524 36.0131 9.64166 34.3349 5.64974 36.2497L5.64868 36.2502L4.55556 36.773L4.5538 36.7738C0.555257 38.6925 -1.12423 43.5054 0.791862 47.4984L0.792307 47.4994L14.0349 75.0482L12.3583 81.2944C12.1436 82.0945 12.6181 82.9172 13.4182 83.132C14.2183 83.3467 15.041 82.8722 15.2558 82.0721L17.0766 75.2886C17.1696 74.942 17.1353 74.5734 16.9798 74.2499L3.49659 46.2006C2.29481 43.6961 3.3521 40.6786 5.85075 39.479L5.85167 39.4786L6.9448 38.9558L6.94655 38.9549C9.45132 37.753 12.4693 38.8107 13.6686 41.31L13.6713 41.3157L16.5632 47.278C16.7551 47.6736 17.1108 47.965 17.5364 48.0754L17.851 48.1569C21.5235 49.1431 25.2887 46.9476 26.2755 43.289L26.2761 43.2865L34.6305 12.0944L34.6312 12.0918C35.2622 9.71899 37.6984 8.3099 40.0794 8.94306C42.4521 9.57399 43.8611 12.0099 43.2283 14.3907L43.2282 14.3913L35.898 41.7606C35.6836 42.5608 36.1586 43.3833 36.9588 43.5976C37.7591 43.8119 38.5815 43.337 38.7958 42.5367L41.8908 30.9809L48.2448 34.861C48.0181 35.0518 47.8456 35.3116 47.7631 35.6195L44.6808 47.1276C44.4665 47.9278 44.9414 48.7503 45.7417 48.9646C46.5419 49.179 47.3643 48.704 47.5787 47.9038L50.661 36.3957C50.6656 36.3785 50.6698 36.3614 50.6738 36.3443L57.0744 40.2528C56.8189 40.447 56.6234 40.7244 56.534 41.0585L53.4755 52.4833C53.2612 53.2835 53.7363 54.1059 54.5366 54.3202C55.3368 54.5344 56.1592 54.0593 56.3734 53.2591L59.4319 41.8343C59.4431 41.7927 59.4524 41.751 59.4598 41.7094L65.5858 45.4502L58.0785 73.47L47.7516 82.6443C47.5326 82.8389 47.3754 83.0933 47.2993 83.3762L45.4785 90.1478C45.2634 90.9478 45.7375 91.7707 46.5375 91.9858C47.3375 92.2009 48.1604 91.7268 48.3756 90.9268L50.0798 84.5888L60.4072 75.414C60.6266 75.2191 60.784 74.9642 60.8599 74.6808L68.7739 45.143C68.9461 44.5004 68.6745 43.8212 68.1068 43.4746L42.6999 27.9599L46.1267 15.1648L46.1274 15.1622C47.1842 11.1882 44.8326 7.10276 40.8504 6.04382Z"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M67.328 6.21412C69.0896 8.30144 71.4544 10.6421 73.6624 12.3313C73.771 12.4157 73.8192 12.5243 73.8192 12.6571C73.8192 12.7898 73.7589 12.9104 73.6624 12.9828C71.4544 14.672 69.1016 17.0127 67.3401 19.0879C67.1953 19.2568 67.0022 19.3292 66.7851 19.293C66.2663 19.1965 65.3251 18.6898 64.9873 18.2554C64.8546 18.0865 64.8305 17.8693 64.9149 17.6642C65.2045 16.9765 65.6871 16.0233 66.2783 15.0822C63.5636 14.9857 59.8957 14.7926 57.7601 14.6237C57.4585 14.5996 57.2292 14.4065 57.1569 14.129C57.0483 13.7309 56.9879 13.2121 56.9879 12.6571C56.9879 12.102 57.0483 11.5832 57.1569 11.1851C57.2292 10.9076 57.4706 10.7145 57.7601 10.6904C59.8957 10.5094 63.5636 10.3284 66.2783 10.2319C65.6871 9.2908 65.2045 8.33763 64.9149 7.6499C64.8305 7.44479 64.8546 7.22761 64.9873 7.0587C65.3251 6.62434 66.2663 6.11759 66.7851 6.02107C67.0022 5.98487 67.2074 6.05726 67.3401 6.22618L67.3401 6.21412L67.328 6.21412Z"
				fill="#F7B907"
			>
				<animateTransform
					attributeName="transform"
					attributeType="XML"
					type="translate"
					values="-10 0; 0 0; -10 0"
					dur="1s"
					repeatCount="indefinite"
				/>
			</path>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M10.4792 6.21422C8.71761 8.30154 6.35278 10.6302 4.15687 12.3193C4.04828 12.4038 4.00002 12.5124 4.00002 12.6451C4.00002 12.7778 4.06035 12.8985 4.15687 12.9709C6.36484 14.66 8.71761 17.0007 10.4792 19.076C10.6239 19.2449 10.817 19.3173 11.0342 19.2811C11.553 19.1846 12.4941 18.6778 12.8319 18.2435C12.9646 18.0745 12.9888 17.8574 12.9043 17.6522C12.6147 16.9645 12.1321 16.0113 11.5409 15.0702C14.2556 14.9737 17.9235 14.7807 20.0591 14.6118C20.3607 14.5876 20.59 14.3946 20.6624 14.1171C20.771 13.7189 20.8313 13.2001 20.8313 12.6451C20.8313 12.0901 20.771 11.5713 20.6624 11.1731C20.59 10.8956 20.3487 10.7026 20.0591 10.6784C17.9235 10.4974 14.2556 10.3165 11.5409 10.2199C12.1321 9.27884 12.6147 8.32567 12.9043 7.63794C12.9888 7.43283 12.9646 7.21565 12.8319 7.04673C12.4941 6.61238 11.553 6.10563 11.0342 6.00911C10.817 5.97291 10.6119 6.0453 10.4792 6.21422Z"
				fill="#F7B907"
			>
				<animateTransform
					attributeName="transform"
					attributeType="XML"
					type="translate"
					values="-5 0; 5 0; -5 0"
					dur="1s"
					repeatCount="indefinite"
				/>
			</path>
			<defs>
				<radialGradient
					id="paint0_radial_391_2151"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(38.9891 12.6464) rotate(90) scale(11.9008)"
				>
					<stop stop-color="#FFB2BA" />
					<stop offset="1" stop-color="#E82F41" />
				</radialGradient>
			</defs>
		</svg>
	);
}

export default DragFingerIcon;
